(function () {
  const initAsideMenu = () => {
    const header = document.querySelector(".header-wrapper");
    const asideMenu = document.querySelector(".aside-menu");
    const openAsideMenuBtn = document.querySelector(".aside-menu__toggle--open-btn");
    const asideMenuOverlay = document.querySelector(".aside-menu__overlay");

    if (!asideMenu || !openAsideMenuBtn) return;

    if (header) header.preventHide = false;

    const isMobile = () => window.innerWidth < 1100;

    const openAsideMenu = (e) => {
      if (!isMobile()) return;
      e.preventDefault();
      if (header) header.preventHide = true;
      asideMenu.classList.add("aside-menu--open");
      asideMenuOverlay.classList.add("aside-menu__overlay--active");
      document.body.classList.add("overflow-hidden-drawer");
    };

    const closeAsideMenu = (e) => {
      if (!isMobile()) return;
      e.preventDefault();
      asideMenu.classList.remove("aside-menu--open");
      asideMenuOverlay.classList.remove("aside-menu__overlay--active");
      document.body.classList.remove("overflow-hidden-drawer");
      if (header) header.preventHide = false;
    };

    openAsideMenuBtn.addEventListener("click", openAsideMenu);
    asideMenuOverlay.addEventListener("click", closeAsideMenu);

    const closeBtn = asideMenu.querySelector(".js-aside-menu-close");
    if (closeBtn) closeBtn.addEventListener("click", closeAsideMenu);

    asideMenu.addEventListener("keydown", (e) => {
      if (e.code === "Escape") {
        closeAsideMenu(e);
        openAsideMenuBtn.classList.toggle("menu-opening");
      }
    });
  };

  document.addEventListener("shopify:section:load", initAsideMenu);
  document.addEventListener("shopify:section:unload", initAsideMenu);
  document.addEventListener("shopify:section:reorder", initAsideMenu);

  initAsideMenu();
})();
